module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 98
// module chunks = 4